export interface ProjectListHeaderProps {
  onCollapseChange: () => void;
  projectName: Project['projectName'];
  isSub: Project['isSub'];
  id: Project['id'];
}
export interface SubProject {
  id: string;
  rating: number;
  projectName: string;
  country: string;
  sector: string;
  sector2: string;
  year: number;
  description: string;
  lessonsLearnt: string[];
  subProjects: SubProject[];
  reportUrl: string;
}

export interface Project {
  id: string;
  rating: number;
  projectName: string;
  country: string;
  sector: string;
  sector2: string;
  year: number;
  description: string;
  lessonsLearnt: string[];
  subProjects: SubProject[];
  reportUrl: string;
  isSub?: boolean;
}

export interface AverageRating {
  overall?: number;
  relevance?: number;
  coherence?: number;
  effectivity?: number;
  efficiency?: number;
  impact?: number;
  sustainability?: number;
}

export interface ProjectsOverviewStoreType {
  projectList: Project[];
  numberOfItems: number;
  numberOfPages: number;
  averageRating: AverageRating;
  isError: boolean;
}

export enum ProjectsOverviewStoreKind {
  INITIAL = 'INITIAL',
  ERROR = 'ERROR',
}

export type ProjectsOverviewStoreAction =
  | {
      type: ProjectsOverviewStoreKind.INITIAL;
      payload: ProjectsOverviewStoreType;
    }
  | {
      type: ProjectsOverviewStoreKind.ERROR;
    };
